import { IItemTemplateTiming } from '@dadohr/shared/domainTypes/experience';
import { ETVariableStart } from '../../../../components/ExperienceTimeline';

export type VariableStartInfo = {
  variableStart: ETVariableStart | null;
  // true for 'triggered' timing — its position is already derived from the
  // firing item (getPresumedStartPositionEvaluatingTriggerChains), and its
  // cause is better expressed as an incoming trigger arrow than a gradient
  // ring, so it is NOT surfaced as a variableStart glyph.
  approximate: boolean;
};

// Maps a task/message/automation's timing to the icon language's
// "variable start" concept. Only `dataChange` timing produces a
// variable-start glyph; `triggered` timing is deliberately excluded (see
// `approximate` above) — a real, documented deviation from the design doc,
// which lumps both together.
//
// KNOWN GAP: there is no string-returning humanizer for `Rule<string>`
// (RuleBuilder is a UI, not a text formatter) — a `rules`-driven condition
// falls back to a generic reason string rather than describing the actual
// rule. Revisit once/if a humanizer exists.
export const getVariableStartInfo = (timing: IItemTemplateTiming): VariableStartInfo => {
  if (timing.type === 'dataChange') {
    if (timing.rules) {
      return {
        variableStart: { kind: 'condition', reason: 'Starts when: a custom condition is met' },
        approximate: false
      };
    }
    if (timing.watchField) {
      return {
        variableStart: {
          kind: 'field',
          reason: `Starts when: the "${timing.watchField}" field changes`
        },
        approximate: false
      };
    }
    return {
      variableStart: { kind: 'condition', reason: 'Starts based on a data-change condition' },
      approximate: false
    };
  }
  if (timing.type === 'triggered') {
    return { variableStart: null, approximate: true };
  }
  return { variableStart: null, approximate: false };
};
